<template>
    <div :class="classes">
        <h1 :class="['text-white text-sm lg:text-xl font-bold lg:mb-0', showHeaderButton ? 'mb-8' : '']">{{ $__('header.partner-portal') }}</h1>

        <a v-if="showHeaderButton" :href="route($page.props.locale + '.opportunities.create')"
           class="header__button text-white flex border rounded border-white items-center justify-center w-full sm:max-w-xs lg:w-auto lg:max-w-none py-2 lg:py-3 px-4"
        >
            <PlusCircleIcon class="mr-2"/>
            {{ $__('opportunities.add') }}
        </a>
    </div>
</template>

<script>
import PlusCircleIcon from '@/Components/Icons/PlusCircle';
export default {
    components: { PlusCircleIcon },
    props: ['class'],

    computed: {
        classes() {
            let classes = ['w-full lg:h-28 header px-4 lg:px-20 flex flex-col lg:flex-row justify-between items-center py-8 lg:py-0'];
            if(this.class) {
                classes.push(this.class);
            }

            return classes.join(' ');
        },
        showHeaderButton() {
            return route().current(this.$page.props.locale + '.opportunities.create') === false;
        }
    }
}
</script>
